import MEETING_STRUCT from '../../entities/meeting';

const CALCULATED_MEETING_STRUCT = {
  ...MEETING_STRUCT,
  TIME: 'time',
};

export default CALCULATED_MEETING_STRUCT;
